import Button from "common/Buttons/Button";
import React, { PropsWithChildren, useRef } from "react";
import type { ButtonProps } from "antd";

interface DebouncedButtonProps extends PropsWithChildren<ButtonProps> {
  clickCooldown?: number;
}

const DebouncedButton = ({
  children,
  clickCooldown = 1000,
  onClick,
  ...props
}: DebouncedButtonProps) => {
  const lastClickTime = useRef<number | undefined>(undefined);

  const allowClick = () => {
    return (
      !lastClickTime.current ||
      performance.now() - lastClickTime.current > clickCooldown
    );
  };

  const modifiedOnClick = (e: any) => {
    if (allowClick()) {
      lastClickTime.current = performance.now();
      onClick?.(e);
    }
  };

  return (
    <Button {...props} onClick={modifiedOnClick}>
      {children}
    </Button>
  );
};

export default DebouncedButton;
